import { gbp, compactMoney } from "@/lib/format";
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";
import { TrendingUp, TrendingDown, LineChart } from "lucide-react";

export default function SpendingInsights({ data }) {
  const { series = [], this_out = 0, last_out = 0, change_pct = null, avg_out = 0 } = data || {};
  const down = change_pct != null && change_pct < 0;

  return (
    <div className="mm-glow-card p-6" data-testid="spending-insights">
      <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-4">
        <div>
          <p className="text-[11px] font-semibold tracking-[0.2em] uppercase text-[#00C896]">Spending insights</p>
          <h3 className="font-display text-lg font-semibold mt-1 flex items-center gap-2"><LineChart className="h-5 w-5 text-slate-400" /> Monthly spend trend</h3>
          <div className="mt-3 flex items-end gap-3">
            <span className="font-num text-3xl font-extrabold tracking-tight">{gbp(this_out)}</span>
            {change_pct != null ? (
              <span data-testid="insights-change" className={`inline-flex items-center gap-1 text-sm font-num mb-1 ${down ? "text-[#00C896]" : "text-rose-400"}`}>
                {down ? <TrendingDown className="h-4 w-4" /> : <TrendingUp className="h-4 w-4" />}
                {Math.abs(change_pct)}%
              </span>
            ) : (
              <span className="text-sm text-slate-500 mb-1">vs last month</span>
            )}
          </div>
          <p className="text-xs text-slate-500 mt-1">
            {down ? "Down" : change_pct != null ? "Up" : "Compared to"} from {gbp(last_out)} last month · {gbp(avg_out)} avg
          </p>
        </div>
      </div>

      <div className="mt-5 h-48">
        <ResponsiveContainer width="100%" height="100%" minWidth={0} minHeight={0}>
          <AreaChart data={series} margin={{ top: 6, right: 6, left: -16, bottom: 0 }}>
            <defs>
              <linearGradient id="mmSpendFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#00C896" stopOpacity={0.35} />
                <stop offset="100%" stopColor="#00C896" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" vertical={false} />
            <XAxis dataKey="label" tick={{ fill: "#5F6C7D", fontSize: 11 }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fill: "#5F6C7D", fontSize: 11 }} axisLine={false} tickLine={false} tickFormatter={compactMoney} width={48} />
            <Tooltip
              cursor={{ stroke: "rgba(0,200,150,0.3)" }}
              contentStyle={{ background: "#14181D", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 12, color: "#F4F6F8" }}
              labelStyle={{ color: "#94A3B8" }}
              formatter={(v) => [gbp(v), "Spent"]}
            />
            <Area type="monotone" dataKey="out" stroke="#00C896" strokeWidth={2.5} fill="url(#mmSpendFill)" dot={{ r: 3, fill: "#00C896" }} activeDot={{ r: 5 }} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
